import {
  GET_LISTUSERS_REQUESTED,
  GET_LISTUSERS_SUCCESS,
  GET_LISTUSERS_FAILED,
  GET_CURRENTUSER_REQUESTED,
  GET_CURRENTUSER_SUCCESS,
  GET_CURRENTUSER_FAILED, GET_FEATURES, GET_FEATURES_SUCCESS,
} from './actionTypes'

export const getConfigurationSuccess = payload => ({
  type: GET_FEATURES_SUCCESS,
  payload
})

export const getConfiguration = () => ({
 type: GET_FEATURES
})

export const getListUsers = listUserId => ({
  type: GET_LISTUSERS_REQUESTED,
  listUserId
})

export const getListUsersSuccess = payload => ({
  type: GET_LISTUSERS_SUCCESS,
  payload
})

export const getListUsersFailed = payload => ({
  type: GET_LISTUSERS_FAILED,
  payload
})

export const getCurrentUser = () => ({
  type: GET_CURRENTUSER_REQUESTED
})

export const getCurrentUserSuccess = payload => ({
  type: GET_CURRENTUSER_SUCCESS,
  payload
})

export const getCurrentUserFailed = payload => ({
  type: GET_CURRENTUSER_FAILED,
  payload
})
